const projects = [
  {
    image: 'images/majac.png',
    gif: 'images/majac.png',
    github: 'https://github.com/frontendcafe/cmyk-grape',
    deploy: 'https://jovial-heisenberg-707def.netlify.app/',
    tecnologies: ['Bootstrap', 'Vainilla JS'],
    title: 'Buscador de Museos de Buenos Aires',
  },
  {
    image: 'images/extracker.png',
    gif: 'images/extracker.png',
    github: 'https://github.com/AndresHense/expense-tracker',
    deploy: 'https://agile-thicket-21223.herokuapp.com/',
    tecnologies: ['React', 'Content', 'MongoDB', 'NodeJs'],
    title: 'Expense Tracker',
  },
  {
    image: 'images/itjobs.png',
    gif: 'images/itjobs.png',
    github: 'https://github.com/AndresHense/it-jobs',
    deploy: 'https://radiant-fortress-67064.herokuapp.com/',
    tecnologies: ['NodeJs', 'PostgreSQL'],
    title: 'IT job search',
  },
  {
    image: 'images/shop-mer.png',
    gif: 'images/shop-mer.png',
    github: 'https://github.com/AndresHense/shop-mern',
    deploy: 'https://shop-mer.herokuapp.com/',
    tecnologies: ['React', 'Redux', 'Bootstrap', 'NodeJs', 'MongoDB'],
    title: 'E-commerce',
  },
];

export default projects;
